// extracted by mini-css-extract-plugin
export default {"task-row":"TaskRow_task-row__QDZCB","taskRow":"TaskRow_task-row__QDZCB","layer":"TaskRow_layer__w8e5i"};